import { render } from "./ResumeSectionVessels.vue?vue&type=template&id=2a0625cc"
import script from "./ResumeSectionVessels.vue?vue&type=script&lang=js"
export * from "./ResumeSectionVessels.vue?vue&type=script&lang=js"

import "./ResumeSectionVessels.vue?vue&type=style&index=0&id=2a0625cc&lang=css"
script.render = render

export default script